import { PDFFlyerTemplateOptions, PDFTagTemplateOptions } from 'config';
import React, { FunctionComponent } from 'react';

interface IProps {
  selectedTemplates: string[];
  setSelectedTemplates: (templates: string[]) => void;
}

const TemplateFilters: FunctionComponent<IProps> = ({ selectedTemplates, setSelectedTemplates }) => {
  const flyerTemplates = PDFFlyerTemplateOptions.map((option) => option.value);
  const tagTemplates = PDFTagTemplateOptions.map((option) => option.value);
  const allFlyersSelected = flyerTemplates.length > 0 && flyerTemplates.every((template) => selectedTemplates.includes(template));
  const allTagsSelected = tagTemplates.length > 0 && tagTemplates.every((template) => selectedTemplates.includes(template));

  const handleTemplateChange = (templateName: string, isChecked: boolean) => {
    if (isChecked) {
      setSelectedTemplates([...selectedTemplates, templateName]);
    } else {
      setSelectedTemplates(selectedTemplates.filter((name) => name !== templateName));
    }
  };

  const handleAllFlyersChange = (isChecked: boolean) => {
    if (isChecked) {
      setSelectedTemplates(Array.from(new Set([...selectedTemplates, ...flyerTemplates])));
      return;
    }

    setSelectedTemplates(selectedTemplates.filter((template) => !flyerTemplates.includes(template)));
  };

  const handleAllTagsChange = (isChecked: boolean) => {
    if (isChecked) {
      setSelectedTemplates(Array.from(new Set([...selectedTemplates, ...tagTemplates])));
      return;
    }

    setSelectedTemplates(selectedTemplates.filter((template) => !tagTemplates.includes(template)));
  };

  return (
    <div className="table__template-filters">
      <div className="table__template-filters--header">
        <label>Filter by Template</label>
        <button
          className="btn btn--inline btn--small"
          type="button"
          onClick={() => setSelectedTemplates([...flyerTemplates, ...tagTemplates])}
        >
          Select All
        </button>
        <button className="btn btn--inline btn--small" type="button" onClick={() => setSelectedTemplates([])}>
          Clear All
        </button>
      </div>

      <h3 id="flyer-templates">
        <input
          type="checkbox"
          id="template-all-flyers"
          checked={allFlyersSelected}
          onChange={(e) => handleAllFlyersChange(e.target.checked)}
          aria-label="Select all flyer templates"
        />
        Flyer Templates:
      </h3>
      <div className="table__template-filters--options">
        {flyerTemplates.map((templateName) => (
          <div key={templateName} className="table__template-filters--option">
            <input
              type="checkbox"
              id={`template-${templateName}`}
              checked={selectedTemplates.includes(templateName)}
              onChange={(e) => handleTemplateChange(templateName, e.target.checked)}
            />
            <label htmlFor={`template-${templateName}`} dangerouslySetInnerHTML={{ __html: templateName }} />
          </div>
        ))}
      </div>

      <h3 id="tag-templates">
        <input
          type="checkbox"
          id="template-all-tags"
          checked={allTagsSelected}
          onChange={(e) => handleAllTagsChange(e.target.checked)}
          aria-label="Select all tag templates"
        />
        Tag Templates:
      </h3>
      <div className="table__template-filters--options">
        {tagTemplates.map((templateName) => (
          <div key={templateName} className="table__template-filters--option">
            <input
              type="checkbox"
              id={`template-${templateName}`}
              checked={selectedTemplates.includes(templateName)}
              onChange={(e) => handleTemplateChange(templateName, e.target.checked)}
            />
            <label htmlFor={`template-${templateName}`} dangerouslySetInnerHTML={{ __html: templateName }} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TemplateFilters;
